module.exports = __webpack_public_path__ + "static/media/UBT-ETH.063edf0a.png";